import { graphql } from "relay-runtime"

export const deUpdateProgressNoteTreatmentPlanMutation = graphql`
  mutation deUpdateProgressNoteTreatmentPlanMutation($input: De_updateProgressNoteTreatmentPlanInput!) {
    updateProgressNoteTreatmentPlan: de_updateProgressNoteTreatmentPlan(input: $input) {
      ProgressNoteMutationOutput: de_ProgressNoteMutationOutput {
        episodeOfCare {
          id
          patientId
          updatedAt
        }
        progressNote {
          id
          updatedAt
          treatmentPlan {
            title
            from
            to
            followUpInstructions
            recommended
          }
        }
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`
